export default __webpack_public_path__ + "static/MaisonNeue-Medium-af3e16e953c039f3b5b25d24bda6b6d8.woff";